const indices = [
  { title: '电竞爆料专区', desc: 'LOL、王者荣耀、CS2等热门电竞项目一手内幕', count: '1.2万条', icon: 'ri-gamepad-line' },
  { title: '体育赛事吃瓜', desc: '足球、篮球、网球等体育圈最新八卦与转会消息', count: '9800条', icon: 'ri-football-line' },
  { title: '综艺选秀揭秘', desc: '各大综艺节目幕后故事、淘汰名单提前曝光', count: '8500条', icon: 'ri-tv-line' },
  { title: '影视剧透爆料', desc: '热播剧集剧情泄露、演员动态、制作内幕', count: '7200条', icon: 'ri-film-line' },
  { title: '音乐圈八卦', desc: '音乐节阵容泄密、歌手动态、演出内幕', count: '6100条', icon: 'ri-music-line' },
  { title: '游戏行业揭秘', desc: '游戏厂商新项目爆料、行业动态、开发内幕', count: '5400条', icon: 'ri-computer-line' },
  { title: '网红达人爆料', desc: '头部主播与网红达人最新动态与争议事件', count: '4800条', icon: 'ri-user-star-line' },
];

export default function ThemeIndex() {
  return (
    <section id="index" className="section-py bg-background-100">
      <div className="section-container">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-accent-500"></div>
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">
            热门专题
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indices.slice(0, 3).map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-lg p-5 border border-background-200/70 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-50 text-primary-600 mb-3">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1.5 font-heading">{item.title}</h3>
              <p className="text-xs text-foreground-600 mb-3 leading-relaxed">{item.desc}</p>
              <span className="text-xs text-primary-600 font-medium">{item.count} 爆料</span>
            </div>
          ))}
          {indices.slice(3).map((item, idx) => (
            <div
              key={idx + 3}
              className="group bg-background-50 rounded-lg p-5 border border-background-200/70 hover:border-accent-300 transition-colors cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-50 text-accent-600 mb-3">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1.5 font-heading">{item.title}</h3>
              <p className="text-xs text-foreground-600 mb-3 leading-relaxed">{item.desc}</p>
              <span className="text-xs text-accent-600 font-medium">{item.count} 爆料</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}